import classNames from 'classnames';
import { observer } from 'mobx-react';
import { useStore } from '../../../core/utils/hook';
import {
    COURSE_PERIOD_STATUS, COURSE_PLAN_NOTIFY_TYPE, COURSE_PLAN_REMIND_TYPE, COURSE_PLAN_STATUS, COURSE_STATUS_COMPLETE,
    DATE_MD_JP, DATE_YMD,
    DATE_YMD_JP,
    EXTENSION_FILE_MAPPER,
    MSG,
    SAMPLE_VIDEOS_CAROUSEL_INTERVAL,
    SETTING_TOOL_CERTIFICATE_TYPE_MAPPER, SHARE_KNOWLEDGE_FILE_TYPE, SYSTEM_PATH, USER_TYPE
} from '../../../core/configs/constants';
import { useEffect, useMemo, useState } from 'react';
import { useRef } from 'react';
import { flowResult } from 'mobx';
import { Link, useNavigate } from 'react-router-dom';
import moment from 'moment';
import { onLoadAccordion, onLoadSwiper } from '../../../core/utils/main';
import VerticalCarousel from '../../../components/CarouselSwiper/VerticalCarousel';
import MessagePopup from '../components/MessagePopup';
import { FormatNumber, ReactNotifications, ShareKnowledgeVideoPlayer } from '../../../components';
import HomeSlideComponent from './HomeSlideComponent';
import TrainingCourseSlideComponent from './TrainingCourseSlideComponent';
import { downloadFileBySignedUrl, splitFileName } from '../../../core/utils/common';

import './styles.scss';
import AddCoursePlanModal from '../components/AddCoursePlanModal';
import AccordionFAQ from '../../../components/Accordion/accordionFAQ';
import { Swiper, SwiperSlide } from 'swiper/react';
import { Navigation } from 'swiper/modules';
import 'swiper/css';
import 'swiper/css/navigation';

/* eslint-disable max-len */
const ModalVideoContent = ({ video, fileId, resumeTime, viewFileProgress }) => {
    if (!video) {
        return (
            <div className='not-show-video'>
                <img src={'/images/img-1.png'} alt='' style={{ height: '100%', objectFit: 'fill' }} />
                <p>後にご覧いただけます。</p>
            </div>
        );
    }

    const handleHeartbeat = (segments, lastTimeViewed) => {
        viewFileProgress(fileId, { segments, lastTimeViewed });
    };

    const handleEndVideo = (segments, lastTimeViewed) => {
        viewFileProgress(fileId, { segments, lastTimeViewed });
    };

    return (
        <ShareKnowledgeVideoPlayer
            options={{
                sources: [
                    {
                        src: video,
                        type: video.toLowerCase().includes('m3u8') ? 'application/x-mpegURL' : 'video/mp4'
                    }
                ]
            }}
            width={570}
            height={250}
            disableForward={false}
            disableAutoPause={true}
            // Resume from the last viewed position (the API returns 0 once the video was watched through).
            lastTimeViewed={resumeTime}
            onHeartbeat={handleHeartbeat}
            onEndVideo={handleEndVideo}
        />
    );
};

const STDHomeScreenNew = observer(() => {
    // other
    const navigate = useNavigate();

    // store
    const {
        authStore: { token, userInfo, showAlertToolCertificate, setShowAlertToolCertificate },
        userStore: { userInfoHeader, coursePeriodStatus, coursePeriodRemaining, onAddTicketPlan, removeUserCourseByCoursePeriodExpireDate, getProfile, profile },
        themeStore: { getAllThemes, themes },
        courseStore: {
            getAllCourses, popularCourses, newCourses, cleanPagingHomeCourses, cleanRecommendCourses,
            lstTrainingCourse, lstTrainingCourseGroupedByTicketPlans, getTrainingCourseList, cleanTrainingCourseList
        },
        ticketStore: { getAllTickets, tickets },
        generalSettingStore: { getGeneralSetting, generalSetting: { faqs, sampleVideos } },
        modalStore: { show, hide, openWarningModal },
        messageStore: { getMessagePopup },
        informationStore: { lstInformation, getAllInformationsForStudent, viewInformation },
        notifyStore: { notifies, getNotifies, cleanNotifiesPaging },
        shareKnowledgeStore: { lstFileShareknowledge, getAllFileShareknowledge, getPresignedUrlsDonwload, viewFileProgress, getFileInfo, clearLstFileShareknowledge },
        coursePlanStore: { deleteCoursePlan }
    } = useStore();

    // state
    const [videoSamplePlayer, setVideoSamplePlayer] = useState({});
    const prevGroupRef = useRef(null);
    const nextGroupRef = useRef(null);

    const formatDataCarouselInformation = useMemo(() => {
        if (!lstInformation || lstInformation?.length < 0) return [];
        return lstInformation.map(item => ({
            key: item.id,
            id: item.id,
            title: item.title,
            url: `${SYSTEM_PATH.INFORMATION_SCREEN}/${item.id}`,
            publicDate: item.publicDate
        }))
    }, [lstInformation]);

    const getStatusPriority = (status) => {
        if ([COURSE_STATUS_COMPLETE.USER_COURSE_NOT_ATTENDED, COURSE_STATUS_COMPLETE.USER_COURSE_ATTENDING, COURSE_STATUS_COMPLETE.USER_COURSE_NOT_DO_TEST].includes(status)) return 0;
        if (status === null) return 1;
        if (status === COURSE_STATUS_COMPLETE.USER_COURSE_APPLY_CERTIFICATE) return 2;
        return 3;
    };

    const sortLstTrainingCourse = useMemo(() => {
        if (lstTrainingCourse?.length > 0) {
            const result = lstTrainingCourse.slice().sort((a, b) => {
                const priorityA = getStatusPriority(a.statusUserCourse);
                const priorityB = getStatusPriority(b.statusUserCourse);
                return priorityA - priorityB;
            });
            return result;
        }
        return [];
    }, [lstTrainingCourse]);

    const groupedTrainingCoursesForHome = useMemo(() => {
        if (lstTrainingCourseGroupedByTicketPlans?.length > 0) {
            return lstTrainingCourseGroupedByTicketPlans.map(item => ({
                ...item,
                courses: (item?.courses || []).slice().sort((a, b) => {
                    const priorityA = getStatusPriority(a.statusUserCourse);
                    const priorityB = getStatusPriority(b.statusUserCourse);
                    return priorityA - priorityB;
                })
            })).filter(item => item.courses?.length > 0);
        }

        if (sortLstTrainingCourse?.length > 0) {
            return [{
                id: 'default',
                name: userInfoHeader?.ticket?.name || '',
                courses: sortLstTrainingCourse
            }];
        }

        return [];
    }, [lstTrainingCourseGroupedByTicketPlans, sortLstTrainingCourse, userInfoHeader?.ticket?.name]);
    const hasMultipleTrainingGroups = groupedTrainingCoursesForHome.length > 1;
    const isSingleGroupSingleCourse = groupedTrainingCoursesForHome.length === 1 && (groupedTrainingCoursesForHome[0]?.courses?.length || 0) <= 1;

    const isMessageAlert = useMemo(() => {
        return token && ((showAlertToolCertificate === 'true' && !userInfoHeader?.isSettingToolcertificate && location.pathname === SYSTEM_PATH.HOME) ||
            (!userInfoHeader?.numberTicket && userInfoHeader?.allowBuyTicket) ||
            (coursePeriodStatus === COURSE_PERIOD_STATUS.ABOUT_TO_EXPIRE) ||
            (userInfoHeader?.registerNewCoursePeriod && userInfoHeader?.coursePeriodNotApply) ||
            (coursePeriodStatus === COURSE_PERIOD_STATUS.EXPIRED && removeUserCourseByCoursePeriodExpireDate)
        )
    }, [token, showAlertToolCertificate, userInfoHeader, coursePeriodStatus, removeUserCourseByCoursePeriodExpireDate])

    const coursePlanStatus = useMemo(() => {
        if (profile?.coursePlan) {
            let colorStatus = '', textStatus = '', status, backgroundColor = '';
            if (profile.coursePlan.currentTickets >= profile.coursePlan.targetTickets) {
                colorStatus = '#008D45',
                textStatus = 'ゴール',
                backgroundColor = '#E0F5E0',
                status = COURSE_PLAN_STATUS.COMPLETED
            } else {
                if (moment().startOf('day').isSameOrBefore(moment(profile.coursePlan.planEndDate).startOf('day'))) {
                    colorStatus = '#FFB900',
                    textStatus = 'トライ',
                    backgroundColor = '#FFF6E0',
                    status = COURSE_PLAN_STATUS.DOING
                } else {
                    colorStatus = '#EB0000',
                    textStatus = 'リトライ',
                    backgroundColor = '#FFEAEA',
                    status = COURSE_PLAN_STATUS.DOING_AND_EXPIRED

                }
            }
            return {
                colorStatus,
                textStatus,
                backgroundColor,
                status
            }
        }
        return null;
    }, [profile]);

    const notifyCoursePlanType = useMemo(() => {
        if (profile?.coursePlan) {
            return Object.values(COURSE_PLAN_NOTIFY_TYPE).filter(type => type.VALUE === profile.coursePlan.notifyType)[0]?.LABEL;
        }
    }, [profile]);

    const remindNotifyDate = useMemo(() => {
        if (profile?.coursePlan) {
            if (profile.coursePlan.remindType === COURSE_PLAN_REMIND_TYPE.ON_EXPIRED_DAY) {
                return moment(profile.coursePlan.planEndDate).add(7, 'hours').format('※通知がYYYY年MM月DD日 HH時mm分に送信されます。');
            } else if (profile.coursePlan.remindType === COURSE_PLAN_REMIND_TYPE.BEFORE_EXPIRED && profile.coursePlan.remindDateDuration) {
                return moment(profile.coursePlan.planEndDate).subtract(profile.coursePlan.remindDateDuration, 'days').add(7, 'hours').format('※通知がYYYY年MM月DD日 HH時mm分に送信されます。')
            }
        }
        return null;
    }, [profile]);

    // lifecycle
    useEffect(() => {
        cleanPagingHomeCourses();
        cleanRecommendCourses();
        getAllThemes();
        getAllCourses({ highlight: true, isHomeList: true }, 1);
        getAllCourses({ isHomeList: true }, 2);
        if (token) {
            getAllInformationsForStudent({ isHomepage: true });
            getAllCourses({ isRecommendCourse: true, isHomeList: true }, 3);
            getProfile({ isHomePage: true });
            getNotifies({ size: -1, status: 1 });
        }
        getAllTickets({ status: 1 });
        getGeneralSetting({ type: 'faqs' });
        if (!token) {
            getGeneralSetting({ type: 'sample_videos' });
        }
        return () => {
            cleanTrainingCourseList();
            clearLstFileShareknowledge();
            cleanNotifiesPaging();
        }
    }, [])

    useEffect(() => {
        // show message popup
        if (userInfo) {
            fetchMessagePopup();
        }
    }, [])

    useEffect(() => {
        if (tickets?.length > 0) {
            onLoadSwiper('slider-price', '.swiper-scrollbar-price', '#navigation-right-1', '#navigation-left-1', 392, false, false, 3.5, 2.5, 1.25, 24);
        }
    }, [tickets])

    useEffect(() => {
        if (faqs?.length > 0) {
            onLoadAccordion();
        }
    }, [faqs])

    useEffect(() => {
        if (token) {
            if (userInfoHeader?.isTrainingPeriod) {
                getTrainingCourseList({ isHomeList: true, groupByTicketPlan: true })
            }
            if (userInfoHeader?.isAllowShareKnowledge && userInfo.groupId) {
                getAllFileShareknowledge({ isHomePage: true })
            }
        }
    }, [userInfoHeader])

    // function
    const fetchMessagePopup = async () => {
        const isGetMessagePopup = sessionStorage.getItem('isGetMessagePopup');
        if (isGetMessagePopup == 'true') {
            const res = await getMessagePopup();
            if (res?.data) {
                onShowMessagePopup();
            }
            sessionStorage.setItem('isGetMessagePopup', false);
        }
    }

    const onInitVideoPlayer = (player, index) => {
        setVideoSamplePlayer(prevState => ({
            ...prevState,
            [index]: player
        }))
    }

    const onChangeViewVideoSample = () => {
        if (videoSamplePlayer) {
            Object.values(videoSamplePlayer).forEach(player => player?.pause());
        }
    }

    const onShowMessagePopup = () => {
        show({
            id: 'modal-message-popup',
            isOpen: true,
            notButtonX: true,
            onCancel: () => hide(),
            children: (
                <MessagePopup />
            ),
            type: 'medium'
        })
    }

    const onCloseToolCertificateAlert = () => {
        localStorage.setItem('showAlertToolCertificate', false);
        setShowAlertToolCertificate(false);
    }

    const onNavigateToolCertificate = () => {
        navigate(SYSTEM_PATH.TOOL_CERTIFICATE);
    }

    const onHandleNavigateDetailSlide = async (id) => {
        const res = await flowResult(viewInformation(id, {}));
        if (res) return res;
        return null;
    }

    const formatAveragePercent = (percent) => {
        return percent % 1 === 0 ? percent.toString() : percent.toFixed(1)
    }

    const onShowPlayVideo = async (video, fileName, fileId) => {
        const fileInfo = await flowResult(getFileInfo(fileId));
        if (fileInfo) {
            show({
                id: 'modal-play-video-share-knowledge',
                header: <div className='line-clamp-1' style={{ wordBreak: 'break-all' }}>{fileName}</div>,
                isOpen: true,
                onCancel: () => {
                    if (token) {
                        if (userInfo.groupId) {
                            getAllFileShareknowledge({ isHomePage: true }, true)
                        }
                    }
                    hide();
                },
                children: (
                    <div style={{ padding: '15px' }}>
                        <ModalVideoContent
                            video={video}
                            fileId={fileId}
                            resumeTime={fileInfo.lastTimeViewed ?? 0}
                            viewFileProgress={viewFileProgress}
                        />
                    </div>
                ),
                type: 'medium max-width-600'
            });
        }
    };

    const onDownload = async ({ id, name, url }) => {
        const { ext } = splitFileName(name);
        const res = await getPresignedUrlsDonwload({
            id
        });
        if (ext === 'pdf') {
            if (res) {
                window.open(url, '_self');
            }
        } else {
            if (res) {
                downloadFileBySignedUrl(res.url);
            }
        }
    };

    const handleShowAddCoursePlanPopup = () => {
        show({
            id: 'modal-add-course-plan',
            header: <div style={{ fontSize: '22px' }}>計画を設定</div>,
            isOpen: true,
            onCancel: () => {
                hide();
            },
            children: (
                <AddCoursePlanModal coursePeriod={profile.startCurrentCoursePeriod} />
            ),
            type: 'medium min-width-750'
        });
    }

    const handleResetCoursePlan = () => {
        openWarningModal(MSG['warning.student.reset_course_plan'], async () => {
            const res = await flowResult(deleteCoursePlan(profile.coursePlan.id));
            if (res) {
                ReactNotifications('success', MSG['inform.success.delete']);
                getProfile({ isHomePage: true });
            }
        })
    }

    const handleCancelCoursePlan = () => {
        openWarningModal(MSG['warning.student.cancel_course_plan'], async () => {
            const res = await flowResult(deleteCoursePlan(profile.coursePlan.id));
            if (res) {
                ReactNotifications('success', MSG['inform.success.update']);
                getProfile({ isHomePage: true });
            }
        })
    }

    return (
        <div id='main' className='wrapper std-home-screen'>
            <section className={classNames('Banner-Home', isMessageAlert ? 'mg-t-5' : '')}>
                {
                    token && showAlertToolCertificate === 'true' && !userInfoHeader?.isSettingToolcertificate && location.pathname === SYSTEM_PATH.HOME ? (
                        <div className='header-tool-certificate-alert'>
                            <div className='d-flex align-items-start flex-gap-5'>
                                <img src="/images/warning_icon.svg" alt="" />
                                <span>単位管理ツールの設定がされていません。お早めの設定をおすすめします。単位管理ツール画面へ移動するには<a role='button' className='color-link' onClick={onNavigateToolCertificate}>こちら</a>をクリックしてください。</span>
                            </div>
                            <i className='close-icon fa-duotone fa-solid fa-xmark cursor-pointer' onClick={onCloseToolCertificateAlert}></i>
                        </div>
                    ) : <></>
                }

                {
                    token && !userInfoHeader?.numberTicket && userInfoHeader?.allowBuyTicket && (
                        !userInfoHeader?.totalTicket ? (
                            <div className='header-tool-certificate-alert'>
                                <div className='d-flex align-items-start flex-gap-5'>
                                    <img src="/images/warning_icon.svg" alt="" />
                                    <span>受講プランがまだございません。各講座を受講するために、<a role='button' className='color-link' onClick={onAddTicketPlan}>受講プランを購入</a>してください。</span>
                                </div>
                            </div>
                        ) : (
                            <div className='header-tool-certificate-alert'>
                                <div className='d-flex align-items-start flex-gap-5'>
                                    <img src="/images/warning_icon.svg" alt="" />
                                    <span>受講プランがすべて使用されました。各講座を引き続き受講するために、<a role='button' className='color-link' onClick={onAddTicketPlan}>新しい受講プランを追加</a>してください。</span>
                                </div>
                            </div>
                        )
                    )
                }

                {
                    token && coursePeriodStatus === COURSE_PERIOD_STATUS.ABOUT_TO_EXPIRE &&
                    (
                        (userInfoHeader?.registerNewCoursePeriod && userInfoHeader?.coursePeriodNotApply) ? (
                            <div className='header-tool-certificate-alert'>
                                <div className='d-flex align-items-start flex-gap-5'>
                                    <img src="/images/warning_icon.svg" alt="" />
                                    <span>残り{coursePeriodRemaining}日で受講期間満了となります。まだ単位数が残っている場合は受講を行ってください。受講中の講座は新たな受講期間で継続受講が可能です。</span>
                                </div>
                            </div>
                        ) : (
                            <div className='header-tool-certificate-alert'>
                                <div className='d-flex align-items-start flex-gap-5'>
                                    <img src="/images/warning_icon.svg" alt="" />
                                    <span>残り{coursePeriodRemaining}日で受講期間満了となります。受講プランの全ての単位数の受講を完了させてください。</span>
                                </div>
                            </div>
                        )
                    )
                }

                {
                    token && userInfoHeader?.registerNewCoursePeriod && userInfoHeader?.coursePeriodNotApply && (
                        <div className='header-tool-certificate-alert'>
                            <div className='d-flex align-items-start flex-gap-5'>
                                <img src="/images/warning_icon.svg" alt="" />
                                <span>{moment(userInfoHeader.coursePeriodNotApply).format(DATE_YMD_JP)}よりご予約された新規の受講期間となります。</span>
                            </div>
                        </div>
                    )
                }

                {
                    token && coursePeriodStatus === COURSE_PERIOD_STATUS.EXPIRED && removeUserCourseByCoursePeriodExpireDate &&
                    moment().isBefore(moment(removeUserCourseByCoursePeriodExpireDate)) && (
                        <div className='header-tool-certificate-alert'>
                            <div className='d-flex align-items-start flex-gap-5'>
                                <img src="/images/warning_icon.svg" alt="" />
                                <span>{moment(removeUserCourseByCoursePeriodExpireDate).format(DATE_MD_JP)}までに受講プランをお申込みの場合、受講中で終了した講座の受講履歴から開始することができます。</span>
                            </div>
                        </div>
                    )
                }

                {
                    !token &&
                    <>
                        <div className='img-banner banner-web'>
                            <a><img src='/images/banner-txt.png' alt='' /></a>
                        </div>
                        <div className='img-banner banner-mobile'>
                            <a><img src='/images/banner.png' alt='' /></a>
                        </div>
                        <div className='content-banner banner-mobile'>
                            <div className='content'>
                                <h2 className='title-1'>選ばれる薬剤師に一歩近づく！</h2>
                                <h2 className='title-1'>臨床力が身につくeラーニングサイト</h2>
                                <p className='desc'>elephamtのすべての配信コンテンツは研修認定薬剤師の単位対象講座となります。</p>
                            </div>
                        </div>
                    </>
                }
                {
                    token && (
                        <>
                            {
                                lstInformation?.length > 0 && (
                                    <div className='carousel-information d-flex align-items-center bg-gray'>
                                        <div className='carousel-information-title'>
                                            <span style={{ color: '#FFB900' }} className=''>Pharma Info</span>
                                            <div
                                                className='pd-lr-20 view-lst-information-hyperlink-title'
                                                onClick={() => navigate(SYSTEM_PATH.INFORMATION_SCREEN)}
                                            ><span className='hyperlink'>一覧をみる</span>{'>'}{'>'}</div>
                                        </div>
                                        <VerticalCarousel
                                            className='height-40'
                                            slides={formatDataCarouselInformation}
                                            useTooltipHover
                                            allowTouchMove={false}
                                            onHandleNavigateDetailSlide={onHandleNavigateDetailSlide}
                                        />
                                        <div
                                            className='pd-lr-20 view-lst-information-hyperlink'
                                            onClick={() => navigate(SYSTEM_PATH.INFORMATION_SCREEN)}
                                        ><span className='hyperlink'>一覧をみる</span>{'>'}{'>'}</div>
                                    </div>
                                )
                            }
                        </>
                    )

                }
            </section>

            {
                token && (
                    <section className='content-home container mg-t-35'>
                        <div className={classNames('content-home-info')}>
                            <div className='content-home-info-header'>
                                <div className='heading'>【お知らせ】</div>
                                {
                                    notifies?.length > 0 ? (
                                        <div className='content cursor-pointer' onClick={() => navigate(`/notification/${notifies[0].id}`)}>
                                            <div className='public-date'>{moment(notifies[0].releaseDate).format(DATE_YMD)}</div>
                                            <div className='title line-clamp-1'>{notifies[0].title}</div>
                                        </div>
                                    ) : <div className='content'>
                                        <div className='title'>お知らせがありません。</div>
                                    </div>
                                }
                            </div>
                            <div className='content-home-info-content'>
                                <div className='header-container'>
                                    <div className='header'>
                                        <div className='user-info cursor-pointer' onClick={() => navigate(SYSTEM_PATH.PROFILE_EDIT)}>
                                            <div className='user-info-avatar'>
                                                <i className='fa-regular fa-user'></i>
                                            </div>
                                            <div className='user-info-name line-clamp-1'>
                                                <div className='name'>{`${profile?.firstName || ''}${profile?.lastName || ''}様`}</div>
                                            </div>
                                        </div>
                                        {
                                            profile?.startCurrentCoursePeriod && profile?.endCurrentCoursePeriod && (
                                                <div className='course-period'>
                                                    <div className='text'>受講期間</div>
                                                    <div className='value'>{`${moment(profile.startCurrentCoursePeriod).format(DATE_YMD)}~${moment(profile.endCurrentCoursePeriod).format(DATE_YMD)}`}</div>
                                                </div>
                                            )
                                        }
                                    </div>
                                    <div className='header-info-container'>
                                        <div className={classNames('header-info', !(profile?.startCurrentCoursePeriod && profile?.endCurrentCoursePeriod) && 'full')}>
                                            <div className='header-info-item'>
                                                <div className='label flex-none'>【契約内容】</div>
                                                <div className='content content-contract'>
                                                    {profile?.roleId === USER_TYPE.STUDENT_GROUP ? '法人契約 ' : '個人契約 '}
                                                    ({profile?.groupName})
                                                </div>
                                            </div>
                                            <div className='header-info-item'>
                                                <div className='label flex-none'>【受講プラン】</div>
                                                <div className='content'>{userInfoHeader?.ticket?.name || '--'}</div>
                                            </div>
                                            <div className='header-info-item'>
                                                <div className='label flex-none'>【薬剤師名簿登録番号】</div>
                                                <div className='content line-clamp-1'>{profile?.pharmacistNumber || '--'}</div>
                                            </div>
                                            <div className='header-info-item'>
                                                <div className='label flex-none'>【研修認定期間】</div>
                                                <div className='content line-clamp-1'>
                                                    {
                                                        profile?.toolCertificateStartPeriod && profile?.toolCertificateEndPeriod && profile?.toolCertificateType ?
                                                            `${moment(profile.toolCertificateStartPeriod).format(DATE_YMD)}~${moment(profile.toolCertificateEndPeriod).format(DATE_YMD)} (${SETTING_TOOL_CERTIFICATE_TYPE_MAPPER[profile.toolCertificateType].LABEL})` :
                                                            '--'
                                                    }
                                                </div>
                                            </div>
                                        </div>
                                        {
                                            profile?.startCurrentCoursePeriod && profile?.endCurrentCoursePeriod && (
                                                <div className='course-plan-info'>
                                                    <div className={classNames('course-plan-header', !profile?.coursePlan && 'border-bottom-light-gray')}>
                                                        <div className='title'>受講計画</div>
                                                        <div className='course-plan-button'>
                                                            {
                                                                coursePlanStatus ? (
                                                                    coursePlanStatus.status === COURSE_PLAN_STATUS.DOING ? (
                                                                        <div className='cursor-pointer d-flex align-items-center flex-gap-5' onClick={handleCancelCoursePlan}>
                                                                            <i className='fa-solid fa-xmark icon' style={{ color: '#027DB4' }}></i>
                                                                            <span className='text'>計画をリセット</span>
                                                                        </div>
                                                                    ) : (
                                                                        <div className='cursor-pointer d-flex align-items-center flex-gap-5' onClick={handleResetCoursePlan}>
                                                                            <i className='fa-solid fa-clock-rotate-left icon' style={{ color: '#027DB4' }}></i>
                                                                            <span className='text'>計画をリセット</span>
                                                                        </div>
                                                                    )
                                                                ) : (
                                                                    <div className='cursor-pointer d-flex align-items-center flex-gap-5' onClick={handleShowAddCoursePlanPopup}>
                                                                        <i className='fa-solid fa-plus icon' style={{ color: '#027DB4' }}></i>
                                                                        <span className='text'>計画を設定</span>
                                                                    </div>
                                                                )
                                                            }
                                                        </div>
                                                    </div>
                                                    {
                                                        profile?.coursePlan ? (
                                                            <>
                                                                <div className='course-plan-period'>
                                                                    <span className='text'>{`${moment(profile.coursePlan.planStartDate).format(DATE_YMD)}~${moment(profile.coursePlan.planEndDate).format(DATE_YMD)}`}</span>
                                                                    <div className='status' style={{ backgroundColor: coursePlanStatus.backgroundColor, color: coursePlanStatus.colorStatus }}>{coursePlanStatus.textStatus}</div>
                                                                </div>
                                                                <div className='course-plan-property'>
                                                                    <div className='course-plan-target'>
                                                                        <img src='/images/icon_target_tickets.svg' alt='' />
                                                                        <span>{`${profile.coursePlan.targetTickets}講座`}</span>
                                                                    </div>
                                                                    {
                                                                        notifyCoursePlanType && (
                                                                            <>
                                                                                <div className='split'></div>
                                                                                <div className='course-plan-remind-notify'>
                                                                                    <i className='fa-solid fa-bell'></i>
                                                                                    <span>{`${profile.coursePlan.remindType === COURSE_PLAN_REMIND_TYPE.ON_EXPIRED_DAY ? '期限日当日' : `${profile.coursePlan.remindDateDuration}日前`}（${notifyCoursePlanType}）`}</span>
                                                                                    <img
                                                                                        data-bs-toggle="tooltip"
                                                                                        data-bs-placement="bottom"
                                                                                        title={remindNotifyDate}
                                                                                        style={{ height: '13px', width: '13px' }}
                                                                                        src='/images/icon-report-sub.svg'
                                                                                        alt='' />
                                                                                </div>
                                                                            </>
                                                                        )
                                                                    }
                                                                </div>
                                                                <div className='course-plan-progress'>
                                                                    <div className='course-plan-progress-value' style={{ width: `${(profile.coursePlan.currentTickets > profile.coursePlan.targetTickets ? '100' : (profile.coursePlan.currentTickets / profile.coursePlan.targetTickets) * 100)}%`, backgroundColor: coursePlanStatus.colorStatus }}></div>
                                                                </div>
                                                                <div className='course-plan-value'>
                                                                    <span className='title'>計画達成率：</span>
                                                                    <span className='value' style={{ color: coursePlanStatus.colorStatus }}>{`${profile.coursePlan.currentTickets > profile.coursePlan.targetTickets ? '100' : ((profile.coursePlan.currentTickets / profile.coursePlan.targetTickets) * 100).toFixed(0)}%`}</span>
                                                                </div>
                                                            </>
                                                        ) : (
                                                            <div className='course-plan-blank'>
                                                                <div className='course-plan-blank-icon'>
                                                                    <img src='/images/icon-not-setting-course-plan.svg' alt='' />
                                                                </div>
                                                                {/* <div className='course-plan-blank-title'>上記「計画を設定」より受講期限、講座数、リマインドメールの設定が可能です。</div> */}
                                                                <div className='course-plan-blank-desc text-center'>上記「計画を設定」より受講期限、講座数、リマインドメールの設定が可能です。</div>
                                                            </div>
                                                        )
                                                    }
                                                </div>
                                            )
                                        }
                                    </div>
                                </div>
                                <div className='body'>
                                    {
                                        profile?.attendingCourse ? (
                                            <div className='body-course'>
                                                <div className='body-course-thumbnail cursor-pointer' onClick={() => navigate(`/course/${profile.attendingCourse?.id}`)}>
                                                    <img className='thumbnail' src={profile.attendingCourse?.thumbnail || '/images/img-1.png'} alt='' />
                                                </div>
                                                <div className='body-course-theme line-clamp-1'>{profile.attendingCourse?.themeName}</div>
                                                <div className='body-course-name line-clamp-2 cursor-pointer' onClick={() => navigate(`/course/${profile.attendingCourse?.id}`)}>{profile.attendingCourse?.name}</div>
                                                <div className='progress-bar-container'>
                                                    <span style={{ fontSize: '13px', color: '#A8A8A8', fontWeight: '400' }}>視聴進捗率 : </span>
                                                    <span>{`${(profile.attendingCourse?.totalTimeJoin / profile.attendingCourse?.totalTimeCourse * 100).toFixed(0)}%`}</span>
                                                    <div className='progress-bar-total'>
                                                        <div
                                                            className='progress-bar-viewed'
                                                            style={{ width: `${(profile.attendingCourse?.totalTimeJoin / profile.attendingCourse?.totalTimeCourse * 100).toFixed(0)}%` }}>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        ) : (
                                            profile?.recommendCoursesOfStd?.length > 0 ? (
                                                <div className='body-course'>
                                                    <div className='body-course-thumbnail polular-course cursor-pointer' onClick={() => navigate(`/course/${profile.recommendCoursesOfStd[0]?.id}`)}>
                                                        <img className='thumbnail' src={profile.recommendCoursesOfStd[0]?.thumbnail || '/images/img-1.png'} alt='' />
                                                        <div className='thumbnail-tag'>
                                                            <img className='icon' src='/images/icon-polular-course-tag.svg' alt='' />
                                                            <div className='text'>おすすめ講座</div>
                                                        </div>
                                                    </div>
                                                    <div className='body-course-theme line-clamp-1'>{profile.recommendCoursesOfStd[0]?.themeName}</div>
                                                    <div className='body-course-name line-clamp-2 cursor-pointer' onClick={() => navigate(`/course/${profile.recommendCoursesOfStd[0]?.id}`)}>{profile.recommendCoursesOfStd[0]?.name}</div>
                                                </div>
                                            ) : (
                                                popularCourses?.length > 0 ? (
                                                    <div className='body-course'>
                                                        <div className='body-course-thumbnail polular-course cursor-pointer' onClick={() => navigate(`/course/${popularCourses[0]?.id}`)}>
                                                            <img className='thumbnail' src={popularCourses[0]?.thumbnail || '/images/img-1.png'} alt='' />
                                                            <div className='thumbnail-tag'>
                                                                <img className='icon' src='/images/icon-polular-course-tag.svg' alt='' />
                                                                <div className='text'>おすすめ講座</div>
                                                            </div>
                                                        </div>
                                                        <div className='body-course-theme line-clamp-1'>{popularCourses[0]?.themeName}</div>
                                                        <div className='body-course-name line-clamp-2 cursor-pointer' onClick={() => navigate(`/course/${popularCourses[0]?.id}`)}>{popularCourses[0]?.name}</div>
                                                    </div>
                                                ) : (
                                                    <div className='body-content-blank'>
                                                        <img src='/images/LogoWhite.png' style={{ width: '125px', height: '125px' }} alt='logo' />
                                                    </div>
                                                )
                                            )
                                        )
                                    }
                                    <div className='body-statistic'>
                                        <div className='body-statistic-chart'>
                                            <div className='header'>
                                                <div className='text'>学びの結果</div>
                                            </div>
                                            <div className='chart-container'>
                                                <div className='donut-chart-tickets'>
                                                    {
                                                        !profile?.isUnlimitedTicket ? profile?.numberTicketOfCurrentPlan ? (
                                                            <div className={classNames('donut-chart-tickets-container', (profile?.recommendCoursesOfStd?.length <= 0 || profile?.roleId === USER_TYPE.STUDENT_INDIVIDUAL || (profile?.roleId === USER_TYPE.STUDENT_GROUP && (lstFileShareknowledge?.length <= 0 || !userInfoHeader.isAllowShareKnowledge))) && 'scaler')} style={{ background: `conic-gradient( #027DB4 0% ${((profile?.numberTicketCompletedOfCurrentPlan / profile?.numberTicketOfCurrentPlan) * 100).toFixed(0)}%, #CEECFA ${((profile?.numberTicketCompletedOfCurrentPlan / profile?.numberTicketOfCurrentPlan) * 100).toFixed(0)}% 100%)` }}>
                                                                <div className='donut-center-tickets'>
                                                                    <span className={classNames('donut-center-tickets-completed-courses', (profile?.recommendCoursesOfStd?.length <= 0 || profile?.roleId === USER_TYPE.STUDENT_INDIVIDUAL || (profile?.roleId === USER_TYPE.STUDENT_GROUP && (lstFileShareknowledge?.length <= 0 || !userInfoHeader.isAllowShareKnowledge))) && 'donut-center-tickets-completed-courses-scaler')}>{profile?.numberTicketCompletedOfCurrentPlan}</span>
                                                                    <span className={classNames('donut-center-tickets-total-courses', (profile?.recommendCoursesOfStd?.length <= 0 || profile?.roleId === USER_TYPE.STUDENT_INDIVIDUAL || (profile?.roleId === USER_TYPE.STUDENT_GROUP && (lstFileShareknowledge?.length <= 0 || !userInfoHeader.isAllowShareKnowledge))) && 'donut-center-tickets-total-courses-scaler')}>{`/${profile?.numberTicketOfCurrentPlan}`}</span>
                                                                </div>
                                                            </div>
                                                        ) : (
                                                            <div className={classNames('donut-chart-tickets-container', (profile?.recommendCoursesOfStd?.length <= 0 || profile?.roleId === USER_TYPE.STUDENT_INDIVIDUAL || (profile?.roleId === USER_TYPE.STUDENT_GROUP && (lstFileShareknowledge?.length <= 0 || !userInfoHeader.isAllowShareKnowledge))) && 'scaler')} style={{ background: 'conic-gradient( #E6E6E6 0% 100%)' }}>
                                                                <div className={classNames('donut-center-tickets', (profile?.recommendCoursesOfStd?.length <= 0 || profile?.roleId === USER_TYPE.STUDENT_INDIVIDUAL || (profile?.roleId === USER_TYPE.STUDENT_GROUP && (lstFileShareknowledge?.length <= 0 || !userInfoHeader.isAllowShareKnowledge))) && 'donut-center-tickets-scaler')} style={{ fontWeight: '900', color: '#5F5F5F' }}>0</div>
                                                            </div>
                                                        ) : (
                                                            <div className={classNames('donut-chart-unlimited-ticket', (profile?.recommendCoursesOfStd?.length <= 0 || profile?.roleId === USER_TYPE.STUDENT_INDIVIDUAL || (profile?.roleId === USER_TYPE.STUDENT_GROUP && (lstFileShareknowledge?.length <= 0 || !userInfoHeader.isAllowShareKnowledge))) && 'scaler')}>
                                                                <div className='donut-center-tickets'>
                                                                    <span className={classNames('donut-center-tickets-completed-courses')}>{profile?.numberTicketCompletedOfCurrentPlan ?? 0}</span>
                                                                    <span className={classNames('donut-center-tickets-total-courses')}>/無制限</span>
                                                                </div>
                                                            </div>
                                                        )
                                                    }
                                                    <div className='donut-center-tickets-title'>取得単位数</div>
                                                </div>
                                                <div className='donut-chart-test-result'>
                                                    {
                                                        typeof profile?.averageCurrentlyTestResultOfAttendedCourse === 'number' && !isNaN(profile.averageCurrentlyTestResultOfAttendedCourse) ? (
                                                            <div className={classNames('donut-chart-test-result-container', (profile?.recommendCoursesOfStd?.length <= 0 || profile?.roleId === USER_TYPE.STUDENT_INDIVIDUAL || (profile?.roleId === USER_TYPE.STUDENT_GROUP && (lstFileShareknowledge?.length <= 0 || !userInfoHeader.isAllowShareKnowledge))) && 'scaler')} style={{ background: typeof profile?.averageCurrentlyTestResultOfAttendedCourse === 'number' && !isNaN(profile.averageCurrentlyTestResultOfAttendedCourse) ? `conic-gradient( #FFB900 0% ${(profile.averageCurrentlyTestResultOfAttendedCourse).toFixed(1)}%, #FFF3D9 ${(profile.averageCurrentlyTestResultOfAttendedCourse).toFixed(1)}% 100%)` : '' }}>
                                                                <div className='donut-center-test-result' style={{ fontSize: (profile?.recommendCoursesOfStd?.length <= 0 || profile?.roleId === USER_TYPE.STUDENT_INDIVIDUAL || (profile?.roleId === USER_TYPE.STUDENT_GROUP && (lstFileShareknowledge?.length <= 0 || !userInfoHeader.isAllowShareKnowledge))) ? '32px' : '26px' }}>{typeof profile?.averageCurrentlyTestResultOfAttendedCourse === 'number' && !isNaN(profile.averageCurrentlyTestResultOfAttendedCourse) ? `${formatAveragePercent(profile.averageCurrentlyTestResultOfAttendedCourse)}%` : '--'}</div>
                                                            </div>
                                                        ) : (
                                                            <div className={classNames('donut-chart-test-result-blank', (profile?.recommendCoursesOfStd?.length <= 0 || profile?.roleId === USER_TYPE.STUDENT_INDIVIDUAL || (profile?.roleId === USER_TYPE.STUDENT_GROUP && (lstFileShareknowledge?.length <= 0 || !userInfoHeader.isAllowShareKnowledge))) && 'scaler')}>
                                                                <div className='text'>テスト結果なし</div>
                                                            </div>
                                                        )
                                                    }
                                                    <div className='donut-chart-test-result-title'>修了テスト平均正答率</div>
                                                    <div className='donut-chart-test-result-desc'>各講座の最終正答率から算出。</div>
                                                </div>
                                            </div>
                                        </div>
                                        {
                                            profile?.recommendCoursesOfStd?.length > 0 && profile?.roleId === USER_TYPE.STUDENT_GROUP && lstFileShareknowledge?.length > 0 && userInfoHeader.isAllowShareKnowledge && (
                                                <div className='body-statistic-recommend'>
                                                    <div className='header'>あなたにおすすめの講座</div>
                                                    <div className='recommend-course-container'>
                                                        {
                                                            profile.recommendCoursesOfStd.slice(0, 3).map((course, index) => (
                                                                <div
                                                                    key={index}
                                                                    onClick={() => navigate(`/course/${course.id}`)}
                                                                    className='recommend-course-item cursor-pointer line-clamp-1'>{course.name}</div>
                                                            ))
                                                        }
                                                    </div>
                                                </div>
                                            )
                                        }
                                    </div>
                                </div>
                            </div>
                        </div>

                        {
                            profile?.roleId === USER_TYPE.STUDENT_GROUP && (
                                lstFileShareknowledge?.length > 0 && userInfoHeader.isAllowShareKnowledge ? (
                                    <div className='content-home-share-knowleage'>
                                        <div className='header'>
                                            <div className='header-heading'>シェアナレッジ</div>
                                            {
                                                userInfoHeader.isAllowShareKnowledge && lstFileShareknowledge?.length > 0 && (
                                                    <div className='share-knowledge-footer' onClick={() => navigate(SYSTEM_PATH.SHARE_KNOWLEDGE_FILE_LIST)}>
                                                        すべての詳細表示
                                                    </div>
                                                )
                                            }
                                        </div>
                                        <div className={classNames('content', (!userInfoHeader.isAllowShareKnowledge || lstFileShareknowledge?.length <= 0) && 'default-content')}>
                                            {
                                                lstFileShareknowledge.map((file, index) => {
                                                    const { ext } = splitFileName(file.name);
                                                    const typeFile = Object.keys(EXTENSION_FILE_MAPPER).filter(key => EXTENSION_FILE_MAPPER[key].VALUE.includes(ext));
                                                    let icon = '/images/img-1-1.png';
                                                    if (typeFile?.length > 0) {
                                                        icon = EXTENSION_FILE_MAPPER[typeFile[0]].ICON;
                                                    }
                                                    return (
                                                        <div key={index} className='share-knowledge-content-item'>
                                                            {
                                                                file.type === SHARE_KNOWLEDGE_FILE_TYPE.VIDEO ? (
                                                                    <img
                                                                        onClick={() => onShowPlayVideo(file.playUrl, file.name, file.id)}
                                                                        className='thumbnail cursor-pointer' src={file?.thumbnail ? file.thumbnail : '/images/img-1-1.png'} alt=''></img>
                                                                ) : (
                                                                    typeFile?.length > 0 && typeFile[0] === 'IMAGE' ? (
                                                                        <div
                                                                            onClick={() => onDownload(file)}
                                                                            className='cursor-pointer flex-none'>
                                                                            <img style={{ width: '45px', height: '45px', borderRadius: '5px' }}
                                                                                src={file.url} alt='' />
                                                                        </div>
                                                                    ) : (
                                                                        <div
                                                                            onClick={() => onDownload(file)}
                                                                            className='thumbnail-doc cursor-pointer'>
                                                                            <img className='thumbnail' src={icon} alt='' />
                                                                        </div>
                                                                    )
                                                                )
                                                            }
                                                            <div
                                                                onClick={file.type === SHARE_KNOWLEDGE_FILE_TYPE.VIDEO ?
                                                                    () => onShowPlayVideo(file.playUrl, file.name, file.id) :
                                                                    () => onDownload(file)}
                                                                className='file-name line-clamp-2 cursor-pointer'>{file.name}</div>
                                                        </div>
                                                    )
                                                })
                                            }
                                        </div>
                                    </div>
                                ) : (
                                    <div className='content-home-recommend-course'>
                                        <div className='header'>あなたにおすすめの講座</div>
                                        <div className='content'>
                                            {
                                                profile?.recommendCoursesOfStd?.length > 0 ?
                                                    (
                                                        <div className='content'>
                                                            {
                                                                profile.recommendCoursesOfStd.map((course, index) => (
                                                                    <div key={index} className='content-home-recommend-course-item cursor-pointer' onClick={() => navigate(`/course/${course.id}`)}>
                                                                        <img className='thumbnail' src={course?.thumbnail ? course.thumbnail : '/images/img-1.png'} alt='' />
                                                                        <div className='course-name line-clamp-1'>{course.name}</div>
                                                                    </div>
                                                                ))
                                                            }
                                                        </div>
                                                    ) : (
                                                        popularCourses?.length > 0 ? (
                                                            <div className='content'>
                                                                <div className='content-home-recommend-course-item cursor-pointer' onClick={() => navigate(`/course/${popularCourses[0].id}`)}>
                                                                    <img className='thumbnail' src={popularCourses[0]?.thumbnail ? popularCourses[0].thumbnail : '/images/img-1.png'} alt='' />
                                                                    <div className='course-name line-clamp-1'>{popularCourses[0].name}</div>
                                                                </div>
                                                            </div>
                                                        ) : (
                                                            <div className='content default-content'>
                                                                <img src='/images/LogoWhite.png' style={{ width: '160px', height: '160px' }} alt='logo' />
                                                            </div>
                                                        )
                                                    )
                                            }
                                        </div>
                                    </div>
                                )
                            )
                        }
                        {
                            profile?.roleId === USER_TYPE.STUDENT_INDIVIDUAL && (
                                profile?.recommendCoursesOfStd?.length > 0 ? (
                                    <div className='content-home-recommend-course'>
                                        <div className='header'>あなたにおすすめの講座</div>
                                        <div className='content'>
                                            {
                                                profile.recommendCoursesOfStd.map((course, index) => (
                                                    <div key={index} className='content-home-recommend-course-item cursor-pointer' onClick={() => navigate(`/course/${course.id}`)}>
                                                        <img className='thumbnail' src={course?.thumbnail ? course.thumbnail : '/images/img-1.png'} alt='' />
                                                        <div className='course-name line-clamp-1'>{course.name}</div>
                                                    </div>
                                                ))
                                            }
                                        </div>
                                    </div>
                                ) : (
                                    <div className='content-home-recommend-course'>
                                        <div className='header'>あなたにおすすめの講座</div>
                                        {
                                            popularCourses?.length > 0 ? (
                                                <div className='content'>
                                                    <div className='content-home-recommend-course-item cursor-pointer' onClick={() => navigate(`/course/${popularCourses[0].id}`)}>
                                                        <img className='thumbnail' src={popularCourses[0]?.thumbnail ? popularCourses[0].thumbnail : '/images/img-1.png'} alt='' />
                                                        <div className='course-name line-clamp-1'>{popularCourses[0].name}</div>
                                                    </div>
                                                </div>
                                            ) : (
                                                <div className='content default-content'>
                                                    <img src='/images/LogoWhite.png' style={{ width: '160px', height: '160px' }} alt='logo' />
                                                </div>
                                            )
                                        }
                                    </div>
                                )
                            )
                        }
                    </section>
                )
            }

            {
                token && groupedTrainingCoursesForHome?.length > 0 && (
                    <section className='training-course-section container'>
                        <div className='training-course-header'>
                            <div className='title'>
                                {profile?.groupName}の研修指定講座
                            </div>
                            <div className='hyper-link flex-none' onClick={() => navigate(SYSTEM_PATH.TRAINING_LIST)}>すべて表示 &gt;&gt;</div>
                        </div>
                        <div className='training-course-groups-slider'>
                            {
                                hasMultipleTrainingGroups ? (
                                    <>
                                        <Swiper
                                            direction='horizontal'
                                            modules={[Navigation]}
                                            navigation={{
                                                prevEl: prevGroupRef.current,
                                                nextEl: nextGroupRef.current
                                            }}
                                            onInit={(swiper) => {
                                                setTimeout(() => {
                                                    if (swiper.params?.navigation && typeof swiper.params.navigation !== 'boolean') {
                                                        swiper.params.navigation.prevEl = prevGroupRef.current;
                                                        swiper.params.navigation.nextEl = nextGroupRef.current;
                                                        swiper.navigation.init();
                                                        swiper.navigation.update();
                                                    }
                                                });
                                            }}
                                            slidesPerView='auto'
                                            spaceBetween={16}
                                            breakpoints={{
                                                0: { spaceBetween: 10 },
                                                481: { spaceBetween: 16 }
                                            }}
                                        >
                                            {
                                                groupedTrainingCoursesForHome.map((group, index) => (
                                                    <SwiperSlide key={group?.id || index}>
                                                        <div className='training-course-group'>
                                                            <div className='training-course-group-block'>
                                                                {group?.name && (
                                                                    <div className='training-course-group-title'>{group.name}</div>
                                                                )}
                                                                <div className='training-course-content'>
                                                                    <TrainingCourseSlideComponent
                                                                        slides={group?.courses || []}
                                                                        hideNavigation
                                                                        shrinkToContent
                                                                    />
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </SwiperSlide>
                                                ))
                                            }
                                        </Swiper>
                                        <div className='training-course-group-button-container'>
                                            <div ref={prevGroupRef} className='flex-none cursor-pointer'>
                                                <img src='/images/icon-button-left.svg' style={{ height: '33px', width: '33px' }} />
                                            </div>
                                            <div ref={nextGroupRef} className='flex-none cursor-pointer'>
                                                <img src='/images/icon-button-right.svg' style={{ height: '33px', width: '33px' }} />
                                            </div>
                                        </div>
                                    </>
                                ) : (
                                    groupedTrainingCoursesForHome.map((group, index) => (
                                        <div key={group?.id || index} className={classNames('training-course-group', isSingleGroupSingleCourse && 'single-group-single-course')}>
                                            <div className='training-course-group-block'>
                                                {group?.name && (
                                                    <div className='training-course-group-title'>{group.name}</div>
                                                )}
                                                <div className='training-course-content'>
                                                    <TrainingCourseSlideComponent
                                                        slides={group?.courses || []}
                                                        hideNavigation={group?.courses?.length <= 1}
                                                        shrinkToContent
                                                    />
                                                </div>
                                            </div>
                                        </div>
                                    ))
                                )
                            }
                        </div>
                    </section>
                )
            }

            {
                token && profile?.roleId === USER_TYPE.STUDENT_GROUP && lstFileShareknowledge?.length > 0 && userInfoHeader.isAllowShareKnowledge && (
                    <div className='share-knowleage-mobile-section container'>
                        <div className='header'>
                            <div className='header-heading'>シェアナレッジ</div>
                            {
                                userInfoHeader.isAllowShareKnowledge && lstFileShareknowledge?.length > 0 && (
                                    <div className='share-knowledge-footer' onClick={() => navigate(SYSTEM_PATH.SHARE_KNOWLEDGE_FILE_LIST)}>
                                        すべての詳細表示
                                    </div>
                                )
                            }
                        </div>
                        <div className={classNames('content', (!userInfoHeader.isAllowShareKnowledge || lstFileShareknowledge?.length <= 0) && 'default-content')}>
                            {
                                lstFileShareknowledge.map((file, index) => {
                                    const { ext } = splitFileName(file.name);
                                    const typeFile = Object.keys(EXTENSION_FILE_MAPPER).filter(key => EXTENSION_FILE_MAPPER[key].VALUE.includes(ext));
                                    let icon = '/images/img-1-1.png';
                                    if (typeFile?.length > 0) {
                                        icon = EXTENSION_FILE_MAPPER[typeFile[0]].ICON;
                                    }
                                    return (
                                        <div key={index} className='share-knowledge-content-item'>
                                            {
                                                file.type === SHARE_KNOWLEDGE_FILE_TYPE.VIDEO ? (
                                                    <img
                                                        onClick={() => onShowPlayVideo(file.playUrl, file.name, file.id)}
                                                        className='thumbnail cursor-pointer'
                                                        src={file?.thumbnail ? file.thumbnail : '/images/img-1-1.png'} alt=''></img>
                                                ) : (
                                                    typeFile?.length > 0 && typeFile[0] === 'IMAGE' ? (
                                                        <div
                                                            onClick={() => onDownload(file)}
                                                            className='cursor-pointer flex-none'>
                                                            <img style={{ width: '45px', height: '45px', borderRadius: '5px' }}
                                                                src={file.url} alt='' />
                                                        </div>
                                                    ) : (
                                                        <div
                                                            onClick={() => onDownload(file)}
                                                            className='thumbnail-doc cursor-pointer'>
                                                            <img className='thumbnail' src={icon} alt='' />
                                                        </div>
                                                    )
                                                )
                                            }
                                            <div
                                                onClick={file.type === SHARE_KNOWLEDGE_FILE_TYPE.VIDEO ?
                                                    () => onShowPlayVideo(file.playUrl, file.name, file.id) :
                                                    () => onDownload(file)}
                                                className='file-name line-clamp-2 cursor-pointer'>{file.name}</div>
                                        </div>
                                    )
                                })
                            }
                        </div>
                    </div>
                )
            }

            <section className='themes-section container'>
                <div className='themes-title'>テーマから講座を探す</div>
                <div className='themes-content'>
                    {
                        themes?.length > 0 ?
                            themes.map((theme, idx) => (
                                <div key={idx} className='themes-content-container'>
                                    <div
                                        style={{
                                            backgroundImage: "linear-gradient(rgba(78, 169, 83, 0.8), rgba(78, 169, 83, 0.8)), url('/images/theme_bg.png')",
                                            backgroundRepeat: 'no-repeat',
                                            backgroundPosition: 'right center',
                                            backgroundSize: 'cover'
                                        }}
                                        className='themes-content-item'
                                        onClick={() => navigate(`${SYSTEM_PATH.THEMES}?themeId=${theme.id}`)}>
                                        <span className='line-clamp-1' style={{ wordBreak: 'break-all' }}>{theme.name}</span> ({theme.totalCourse})
                                    </div>
                                </div>
                            ))
                            :
                            <div className='col-md-4 col-sm-4 col-xs-12'>
                                データはありません
                            </div>
                    }
                </div>
            </section>

            {
                !token && sampleVideos?.length > 0 &&
                <section className='sample-videos'>
                    <h2 className='title-sample-video text-center mg-b-10'>サンプル動画</h2>
                    <div id='carouselSampleVideos' className='container carousel slide' data-bs-ride='carousel'>
                        {
                            sampleVideos.length > 1 &&
                            <div className='carousel-indicators'>
                                {
                                    sampleVideos.map((e, index) => (
                                        <button key={index} type='button'
                                            data-bs-target='#carouselSampleVideos' data-bs-slide-to={index}
                                            className={index === 0 ? 'active' : ''}
                                            aria-current='true'
                                            aria-label={`Slide ${index + 1}`}
                                            onClick={onChangeViewVideoSample}>
                                        </button>
                                    ))
                                }
                            </div>
                        }
                        <div className='carousel-inner'>
                            {
                                sampleVideos.map((video, index) => (
                                    <div key={index} className={classNames('carousel-item', index === 0 && 'active')} data-bs-interval={SAMPLE_VIDEOS_CAROUSEL_INTERVAL}>
                                        <VideoPlayer
                                            options={{
                                                sources: [
                                                    {
                                                        src: video.url,
                                                        type: video.url?.toLowerCase()?.includes('m3u8') ? 'application/x-mpegURL' : 'video/mp4'
                                                    }
                                                ]
                                            }}
                                            disableForward={false}
                                            onInitVideoPlayer={onInitVideoPlayer}
                                            indexVideoPlayer={index}
                                        />
                                    </div>

                                ))
                            }
                        </div>
                        <button className='carousel-control-prev' type='button' data-bs-target='#carouselSampleVideos' data-bs-slide='prev' onClick={onChangeViewVideoSample}>
                            <i className='carousel-control-icon fa-solid fa-chevron-left'></i>
                            <span className='visually-hidden'>Previous</span>
                        </button>
                        <button className='carousel-control-next' type='button' data-bs-target='#carouselSampleVideos' data-bs-slide='next' onClick={onChangeViewVideoSample}>
                            <i className='carousel-control-icon fa-solid fa-chevron-right'></i>
                            <span className='visually-hidden'>Next</span>
                        </button>
                    </div>
                </section>
            }

            <section className='lst-course-section container' style={{ marginTop: token ? '35px' : '192px' }}>
                <div className='lst-course-header'>
                    <div className='title'>人気の講座から探す</div>
                    <div className='hyper-link' onClick={() => navigate(SYSTEM_PATH.THEMES)}>すべて表示 &gt;&gt;</div>
                </div>
                <div className='lst-course-content'>
                    <HomeSlideComponent slides={popularCourses} />
                </div>
            </section>

            <section className='lst-course-section container'>
                <div className='lst-course-header'>
                    <div className='title'>新しい講座から探す</div>
                    <div className='hyper-link' onClick={() => navigate(SYSTEM_PATH.THEMES)}>すべて表示 &gt;&gt;</div>
                </div>
                <div className='lst-course-content'>
                    <HomeSlideComponent slides={newCourses} />
                </div>
            </section>

            {
                !token &&
                <section className='Price-home'>
                    <div className='container'>
                        {/* <div className='description'>
                        <p>弊社は著作権者からの委託を受け，書籍・雑誌の複製利用の諾否および複製使用料の回収業務を「一般社団法人出版者著作権管理機構（JCOPY）」に再委託しております。 </p>
                        <p>弊社書籍・雑誌を複製利用される際は，JCOPY にご連絡いただき，所定の手続きを行ってくださいますようお願いいたします弊社は著作権者からの委託を受け，書籍・雑誌の複製利用の諾否および複製使用料の回収業務を「一般社団法人出版者著作権管理機構（JCOPY）」に再委託しております。</p>
                    </div> */}
                        <div className='d-flex flex-gap-10 flex-wrap align-items-end'>
                            <h2 className='title-primary'>受講プランのご案内</h2>
                            <div className='warning-not-ticket pd-t-0 px-0 text-start'>＊お申込みの方は先に右上の「新規お申し込み」からアカウント登録をお願いします。</div>
                        </div>
                        <div className='content-price'>
                            {
                                tickets?.length > 0 ?
                                    <>
                                        <div className='btn-slide btn-left-slide' id='navigation-left-1'>
                                            <div className='img-btn-left'>
                                                {/* //<img src='/images/arrow.svg'> */}
                                            </div>
                                        </div>
                                        <div className='btn-slide btn-right-slide' id='navigation-right-1'>
                                            <div className='img-btn-right'>
                                                {/* //<img src='/images/arrow.svg'> */}
                                            </div>
                                        </div>
                                        <div className='slider'>
                                            <div className='slider-price' id='slider-price'>
                                                <div className='swiper-wrapper'>
                                                    {
                                                        tickets.map(e => {
                                                            const courseAmountTicket = e.courses?.length || 0;
                                                            const freeAmountTicket = e.amount - courseAmountTicket;

                                                            return (
                                                                <div key={e.id} className='swiper-slide ticket-card-container'>
                                                                    <div className='item ticket-card'>
                                                                        <h3>
                                                                            <div className='name-ticket'>{e.name}</div>
                                                                            <div>（{e.amount !== null ? <><FormatNumber value={e.amount} />講座</> : '無制限'}）</div>
                                                                        </h3>
                                                                        <div className='nav-item'>
                                                                            <p className='price price-ticket'>
                                                                                <span><FormatNumber value={(e.price || 0) * 11 / 10} />円</span>
                                                                                <span className='note-price-ticket'>(税込)</span>
                                                                            </p>
                                                                            <div className='ticket-info-detail'>
                                                                                {/* {
                                                                                    Boolean(freeAmountTicket) && (
                                                                                        <p className='desc-1 desc-1-1'>
                                                                                            <span className='desc-1-2'>
                                                                                                <i className="fa-solid fa-star"></i> 
                                                                                                <span className='desc-label-1-1'>自由選択単位数</span> 
                                                                                            </span>
                                                                                            <span><FormatNumber value={freeAmountTicket}/>単位</span>
                                                                                        </p>
                                                                                    )
                                                                                }
                                                                                {
                                                                                    Boolean(courseAmountTicket) && (
                                                                                        <p className='desc-1 desc-1-1'>
                                                                                            <span className='desc-1-2'>
                                                                                                <i className="fa-solid fa-star"></i> 
                                                                                                <span className='desc-label-1-1'>指定講座数</span>
                                                                                            </span> 
                                                                                            <span><FormatNumber value={courseAmountTicket}/>講座</span>
                                                                                        </p>
                                                                                    )
                                                                                } */}
                                                                                <p className='desc-1'>
                                                                                    <span className='desc-1-2'>
                                                                                        <i className="fa-solid fa-star"></i>
                                                                                        <span className='desc-label-1-1'>受講期間</span>
                                                                                    </span>
                                                                                    <span><FormatNumber value={e.duration} />カ月</span>
                                                                                </p>
                                                                            </div>
                                                                            <p className='desc-2 height-desc-2 text-justify-inter-word'>{e.description}</p>
                                                                        </div>
                                                                    </div>
                                                                </div>
                                                            )
                                                        })
                                                    }
                                                    <div className={classNames('swiper-slide')}>
                                                        <div className='item item-last'>
                                                            <div className=' item-readMore'>
                                                                <Link role={'button'} to={SYSTEM_PATH.TICKETS}>もっと見る <img src='/images/icon3.svg' alt='' /></Link>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                            {/* scrollbar */}
                                            <div className='swiper-scrollbar-price' />
                                        </div>
                                    </>
                                    :
                                    <div className='mg-t-30 mg-b-95'>
                                        データはありません
                                    </div>
                            }
                        </div>
                    </div>
                </section>
            }
            <section className='section-fqa'>
                <div className='container'>
                    <div className='row'>
                        <div className='col-md-3 col-sm-3 col-xs-12'>
                            <h2 className='title-primary'>よくある質問</h2>
                            {
                                faqs?.length > 0 &&
                                <div className=' item-readMore'>
                                    <Link role={'button'} to={SYSTEM_PATH.FAQ_SCREEN}>もっと見る <img src='/images/icon3.svg' alt='' /></Link>
                                </div>
                            }
                        </div>
                        <div className='col-md-9 col-sm-9 col-xs-12'>
                            <div className='section-fqa-right'>
                                {/* Accordion */}
                                <div className='acc-container'>
                                    {
                                        faqs?.length > 0 ?
                                            faqs.slice(0, 5).map((e, index) => (
                                                <AccordionFAQ item={e} index={index} key={index} containerClassname="faq-screen-container" />

                                                // <div key={e.id} className='acc'>
                                                //     <div className='acc-head'>
                                                //         <p className='title-2'><span className='faq-question'>Q</span>{e.question}</p>
                                                //     </div>
                                                //     <div className='acc-content'>
                                                //         <p className='title-3'> <span className='faq-answer'>A</span><div dangerouslySetInnerHTML={{__html: e.answer}}></div></p>
                                                //     </div>
                                                // </div>
                                            ))
                                            :
                                            <div className='mg-t-20'>データはありません</div>
                                    }
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </section>
        </div>
    )
});

export default STDHomeScreenNew;